import earningHistory from "./earningHistory"
import payments from "./payments"
import {combineReducers} from "redux"

const adminStatisticsReducer = combineReducers({
    earningHistory,
    payments
})

export default adminStatisticsReducer